import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {
  TradeStudyInputs,
  TradeStudyInputsUpdate,
} from '../../models/trade-study-inputs.model';

@Injectable({ providedIn: 'root' })
export class TradeStudyInputsService {
  private http = inject(HttpClient);

  async getTradeStudyInputs(quoteId: string): Promise<TradeStudyInputs> {
    const raw = await firstValueFrom(
      this.http.get<unknown>(
        `/quotes-api/quotes/${quoteId}/trade-study-inputs/`,
      ),
    );
    return TradeStudyInputs.parse(raw);
  }

  async updateTradeStudyInputs(
    quoteId: string,
    data: Partial<TradeStudyInputsUpdate>,
  ): Promise<TradeStudyInputs> {
    const raw = await firstValueFrom(
      this.http.patch<unknown>(
        `/quotes-api/quotes/${quoteId}/trade-study-inputs/`,
        data,
      ),
    );
    return TradeStudyInputs.parse(raw);
  }
}
